var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindSouth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "48px",
    viewBox: "0 0 48 48",
    width: "48px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#48484a",
    fillRule: "evenodd",
    id: "arrow-up",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0839749,20.2226499 L16.0434343,20.2953753 C15.8973068,20.6162383 16.1291771,21 16.5,21 L22,21 L22,39.5 C22,39.7761424 22.2238576,40 22.5,40 L26.5,40 L26.5898756,39.9919443 C26.8231248,39.9496084 27,39.7454599 27,39.5 L27,21 L32.5,21 C32.8993477,21 33.1375434,20.5549273 32.9160251,20.2226499 L24.9160251,8.2226499 C24.7181141,7.92578337 24.2818859,7.92578337 24.0839749,8.2226499 L16.0839749,20.2226499 Z",
    fill: "#000000",
    fillRule: "nonzero",
    id: "Path"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindSouth);
export default __webpack_public_path__ + "static/media/windSouth.46840886528b16dc9bbb67139059b1cb.svg";
export { ForwardRef as ReactComponent };